var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProLevelTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_7351",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EAFDDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_7351)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EAFDDC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_347_7351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 71.8621L112 56L180 71.8621V208.276L112 240L44 208.276V71.8621Z",
    fill: "url(#paint0_linear_347_7351)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1163 205.654V75.1287L112 60.2268L175.884 75.1287V205.654L112 235.458L48.1163 205.654Z",
    stroke: "url(#paint1_linear_347_7351)",
    strokeWidth: 8.23253
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1761 207.527V72.7954L112 57.2076L178.824 72.7954V207.527L112 238.702L45.1761 207.527Z",
    stroke: "url(#paint2_linear_347_7351)",
    strokeOpacity: 0.2,
    strokeWidth: 2.35215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.267 204.051V208.277H100.14V189.242H104.857V204.051H117.27H117.267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.636 189.242V194.506H111.904V189.242H107.187V201.704H111.904V198.759H119.636V208.277H124.323V189.242H119.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3329 131.294H84.1132L86.8511 138.548L89.5043 131.294H92.2281V141.173H90.21V134.554L87.6414 141.173H85.9196L83.3511 134.554V141.173H81.3329V131.294ZM94.6781 141.173L98.291 131.294H100.831L104.416 141.173H102.144L101.382 139.014H97.6277L96.8656 141.173H94.6781ZM98.1922 137.306H100.803L99.4906 133.552L98.1922 137.306ZM110.214 141.257C109.386 141.257 108.667 141.121 108.055 140.848C107.443 140.566 106.968 140.175 106.63 139.677C106.3 139.178 106.131 138.595 106.122 137.927L108.196 137.955C108.234 138.435 108.431 138.825 108.789 139.126C109.156 139.427 109.64 139.578 110.243 139.578C110.732 139.578 111.136 139.479 111.456 139.282C111.776 139.075 111.936 138.774 111.936 138.378C111.936 138.171 111.884 138.002 111.781 137.87C111.687 137.729 111.536 137.616 111.329 137.532C111.122 137.438 110.864 137.358 110.553 137.292C110.252 137.216 109.894 137.136 109.48 137.052C109.066 136.977 108.671 136.878 108.295 136.755C107.919 136.633 107.585 136.468 107.293 136.261C107.001 136.055 106.771 135.786 106.601 135.457C106.432 135.128 106.347 134.709 106.347 134.201C106.347 133.608 106.498 133.091 106.799 132.649C107.1 132.206 107.528 131.858 108.083 131.604C108.638 131.341 109.288 131.209 110.031 131.209C110.812 131.209 111.484 131.336 112.049 131.59C112.623 131.844 113.065 132.206 113.376 132.677C113.696 133.138 113.86 133.684 113.87 134.314H111.795C111.748 133.9 111.569 133.561 111.259 133.298C110.958 133.034 110.548 132.903 110.031 132.903C109.579 132.903 109.208 133.001 108.916 133.199C108.624 133.387 108.478 133.669 108.478 134.046C108.478 134.243 108.525 134.408 108.62 134.54C108.714 134.671 108.859 134.784 109.057 134.878C109.264 134.963 109.518 135.038 109.819 135.104C110.12 135.17 110.478 135.245 110.892 135.33C111.315 135.405 111.715 135.504 112.091 135.626C112.477 135.739 112.816 135.899 113.107 136.106C113.409 136.304 113.644 136.567 113.813 136.897C113.982 137.226 114.067 137.64 114.067 138.139C114.067 138.75 113.907 139.291 113.587 139.762C113.267 140.232 112.816 140.599 112.232 140.862C111.659 141.126 110.986 141.257 110.214 141.257ZM115.898 131.294H123.731V133.114H120.866V141.173H118.749V133.114H115.898V131.294ZM126.408 131.294H133.041V133.114H128.525V135.33H132.195V137.066H128.525V139.352H133.197V141.173H126.408V131.294ZM136.023 131.294H140.045C140.77 131.294 141.405 131.43 141.951 131.703C142.496 131.976 142.92 132.357 143.221 132.846C143.522 133.326 143.672 133.905 143.672 134.582C143.672 135.212 143.517 135.772 143.207 136.261C142.906 136.741 142.496 137.108 141.979 137.362L143.926 141.173H141.584L139.918 137.856H138.14V141.173H136.023V131.294ZM138.14 133.058V136.092H139.876C140.375 136.092 140.77 135.956 141.062 135.683C141.363 135.41 141.513 135.043 141.513 134.582C141.513 134.112 141.363 133.74 141.062 133.467C140.77 133.194 140.375 133.058 139.876 133.058H138.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.395 75.8293L108.395 124.209H109.976L109.976 75.8293H108.395ZM108.395 154.347L108.395 182.898H109.976L109.976 154.347H108.395ZM113.93 124.209L113.93 75.8293H115.511L115.511 124.209H113.93ZM113.93 154.347L113.93 182.898H115.511L115.511 154.347H113.93Z",
    fill: "url(#paint3_linear_347_7351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_347_7351",
    x: 44,
    y: 44.2392,
    width: 136,
    height: 195.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.7608
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.82057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0431373 0 0 0 0 0.0196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_347_7351"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_7351",
    x1: 112,
    y1: 56,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96F550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_7351",
    x1: 112,
    y1: 77.0172,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E3110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E3110",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_7351",
    x1: 112,
    y1: 153.948,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_347_7351",
    x1: 111.953,
    y1: 122.622,
    x2: 111.953,
    y2: 182.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLevelTwo);
export default __webpack_public_path__ + "static/media/pro-level-two.733de255ca1add44a48d77ac86297f86.svg";
export { ForwardRef as ReactComponent };